var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFieldAbc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91015 16.1406C4.76953 16.1406 3.86328 15.4687 3.86328 14.2969C3.86328 12.9219 5.07812 12.6758 6.1914 12.5312C7.28515 12.3906 7.73828 12.4141 7.73828 11.9687C7.73828 11.1914 7.32812 10.7344 6.47265 10.7344C5.59375 10.7344 5.11328 11.2031 4.91016 11.6406L4.03516 11.3281C4.50391 10.2344 5.53515 9.92187 6.4414 9.92187C7.20703 9.92187 8.66015 10.1406 8.66015 12.0469V16H7.73828V15.1875H7.6914C7.5039 15.5781 6.95703 16.1406 5.91015 16.1406ZM6.05078 15.3125C7.14453 15.3125 7.73828 14.5781 7.73828 13.8281V12.9844C7.58203 13.1719 6.53515 13.2812 6.14453 13.3281C5.42578 13.4219 4.78516 13.6406 4.78516 14.3437C4.78516 14.9844 5.3164 15.3125 6.05078 15.3125ZM9.79766 16V8H10.7195V10.9531H10.7977C11.0008 10.6406 11.3602 9.92187 12.532 9.92187C14.0477 9.92187 15.0945 11.125 15.0945 13.0156C15.0945 14.9219 14.0477 16.125 12.5477 16.125C11.3914 16.125 11.0008 15.4062 10.7977 15.0781H10.6883V16H9.79766ZM10.7039 13C10.7039 14.3594 11.3133 15.2969 12.4227 15.2969C13.5789 15.2969 14.1727 14.2812 14.1727 13C14.1727 11.7344 13.5945 10.75 12.4227 10.75C11.2977 10.75 10.7039 11.6562 10.7039 13ZM18.3883 16.125C16.7008 16.125 15.6695 14.8281 15.6695 13.0312C15.6695 11.2031 16.7477 9.92187 18.3727 9.92187C19.6383 9.92187 20.5914 10.6719 20.7477 11.7969H19.8258C19.6852 11.25 19.2008 10.75 18.3883 10.75C17.3102 10.75 16.5914 11.6406 16.5914 13C16.5914 14.3906 17.2945 15.2969 18.3883 15.2969C19.107 15.2969 19.6539 14.9062 19.8258 14.25H20.7477C20.5914 15.3125 19.7164 16.125 18.3883 16.125Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldAbc);
export default ForwardRef;